<template>
  <div
    class="flex-1 max-w-[1680px] w-full mx-auto h-full gb-[#f5f5f5]"
    v-loading="loading"
  >
    <div class="overflow-hidden h-[inherit]">
      <div class="overflow-hidden relative flex flex-col bg-white">
        <steps :current="current"></steps>
        <div class="flex-1 overflow-auto mt-2 createWrap">
          <div class="overflow-auto">
            <!-- 步骤1 -->
            <div v-show="current == 1">
              <!-- 投放目标 -->
              <promotion></promotion>
              <!-- 分割线 -->
              <div
                class="h-[20px] bg-[#f5f5f5]"
                style="height: 20px; background: #f5f5f5"
              ></div>
              <!-- 系列信息 -->
              <campaignInfo
                v-model="data"
                ref="campaignInfo"
                @getAllAdAccountId="getAllAdAccountId"
                @changePromotionLink="changePromotionLink"
                :currentAccount="createAdAccount"
                :enumConstants="enumConstants"
              ></campaignInfo>
            </div>
            <!-- 步骤2 -->
            <div v-show="current == 2">
              <audience
                ref="audience"
                v-model="data.adGroupOptions"
                :data="data"
                :enumConstants="enumConstants"
                :currentStep="current"
                :currentAccount="createAdAccount"
              ></audience>
            </div>
            <!-- 步骤3 -->
            <div v-show="current == 3">
              <creatives
                v-model="data.adOptions"
                :data="data"
                ref="creatives"
                :enumConstants="enumConstants"
                @addCreative="addCreative"
                :currentAccount="createAdAccount"
              ></creatives>
            </div>
            <div v-if="current == 4">
              <track-creat
                v-model="data"
                :enumConstants="enumConstants"
                :params="data"
                ref="trackCreat"
                :currentAccount="createAdAccount"
              ></track-creat>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-between bg-white p-3 mt-2">
        <el-button @click="exit">退出</el-button>
        <div>
          <el-button
            type="primary"
            @click="preStep"
            v-if="current > 1"
            >上一步</el-button
          >
          <el-button
            type="primary"
            @click="nextStep"
            :loading="isNextStepLoading"
            >{{ current == 4 ? '确认' : '下一步' }}</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import steps from './components/steps/index.vue';
import promotion from './components/promotion/index.vue';
import campaignInfo from './components/campaignInfo/index.vue';
import audience from './components/audience/index.vue';
import trackCreat from './components/trackCreat/index.vue';
import {
  getAudienceDefault,
  getImgCreative,
  extractDomain,
  callToActionList,
  budgetTypes,
  bidStrategy,
  statusList,
} from './index.js';
import creatives from './components/creatives/index.vue';
import { adConstMapGG, checkVideo, createStash, getStash } from '@/api/google/create.js';
import { fetchDefaultExcludeRegion } from '@/api/google/adManagement';
import { mapState } from 'vuex';
import moment from 'moment';
import { debounce } from 'lodash';
export default {
  components: { steps, promotion, campaignInfo, audience, creatives, trackCreat },
  data() {
    return {
      loading: false,
      isNextStepLoading: false, // 防止重复点击
      currentAccount: {},
      allAdAccountId: [], // 账户列表
      enumConstants: {
        countries: [],
        languages: [],
        callToActionList,
        budgetTypes,
        bidStrategy,
        statusList,
      },
      current: 1,
      data: {
        type: 'DEMAND_GEN', // 系列类型
        optimizationGoal: '', // 推广目标
        accountId: null, // 广告账户
        promoteInfo: {
          // 推广数据
          promotionLink: '',
          sale: null,
          site: null,
        },
        adGroupOptions: [getAudienceDefault()], // 受众
        adOptions: [getImgCreative()], // 创意
        budgetType: 'DAILY', //默认系列日预算
        bidAmount: null, //竞价值
        budgetAmount: 20, //预算值
        bidStrategy: 'MAX_CONVERSION', //竞价类型
        startDate: moment(new Date()).format('YYYY-MM-DD'),
        //系列跟踪信息
        campaignTraceConfig: {
          enable: false, //是否启用系列跟踪
          /**
           * 推广渠道
           * GMALL3 :GMALL3
           * SHOP_PLUS :SHOP_PLUS
           * SHOPLINE :SHOPLINE
           * SHOPIFY :SHOPIFY
           */
          utmSourceConfig: null,
          tracingTemplateUrl: '', //跟踪模板
        },
      },
    };
  },
  computed: {
    ...mapState('google', ['createAdAccount']),
  },
  watch: {
    createAdAccount: {
      handler(newVal, oldVal) {
        console.log(newVal, 'newVal');
        console.log(oldVal, 'oldVal');
        // 避免重复触发：比较账户ID是否真正发生变化
        if (newVal?.id && newVal.id !== oldVal?.id) {
          this.currentAccount = { ...this.createAdAccount };
          this.$nextTick(() => {
            this.current = 1;
            this.getAccount();
            this.getEnumConstants();
            this.getCreateStash();
            this.$refs.audience.getConstDataList();
          });
        }
      },
      deep: true,
      // immediate: true,
    },
  },
  methods: {
    // 获取当前选中的账户
    getAccount() {
      if (Object.keys(this.createAdAccount).length) {
        this.currentAccount = this.createAdAccount;
      } else {
        if (localStorage.getItem('createAdAccount')) {
          this.currentAccount = JSON.parse(localStorage.getItem('createAdAccount'));
        }
      }

      if (!this.currentAccount?.id) {
        this.currentAccount = {
          id: localStorage.getItem('googleAccountId'),
          accountId: localStorage.getItem('googleAccountId'),
        };
      }
      if (!this.currentAccount.id) {
        this.$message({
          type: 'warning',
          message: '请先选择广告账户，再创建广告',
        });
        return false;
      }
    },
    addCreative() {
      this.data.adOptions.push({
        ...getImgCreative(),
        businessName: extractDomain(this.data.promoteInfo.promotionLink),
      });
    },
    preStep() {
      this.current -= 1;
    },

    // 保存创建数据的缓存
    saveCreateStash() {
      let stashInfo = JSON.stringify({ ...this.data, accountId: this.createAdAccount.id });
      createStash({ stashInfo: stashInfo, accountId: this.createAdAccount.id, type: 'DEMAND_GEN' });
    },

    // 获取创建广告的数据缓存
    async getCreateStash() {
      console.log(this.createAdAccount.id, 'this.currentAccount.id');
      try {
        const res = await getStash({ accountId: this.createAdAccount.id, type: 'SEARCH', type: 'DEMAND_GEN' });
        if (res.code == 0) {
          if (res.data) {
            this.$confirm('是否使用上次缓存数据？', '提示', {
              confirmButtonText: '使用',
              cancelButtonText: '取消',
              type: 'info',
            }).then(() => {
              this.data = JSON.parse(res.data.stashInfo);
              this.data.accountId = this.createAdAccount.id;
              // 如果缓存的开始日期小于当前日期，则使用当前日期
              const today = moment().format('YYYY-MM-DD');
              if (this.data.startDate && this.data.startDate < today) {
                this.data.startDate = today;
              }
            });
          } else {
            this.data.accountId = this.createAdAccount.id;
          }
        }
      } catch {}
    },

    // 获取所有的地区并集
    getAllLocations() {
      let locations = [];
      try {
        this.data.adGroupOptions.forEach((v) => {
          locations = locations.concat(v.groupCriterion.target.locations).map((k) => {
            return {
              id: k.criteria_id,
              code: k.country_code,
              name: k.name,
            };
          });
        });
      } catch {}

      locations = locations.flat();
      locations = Array.from(new Set(locations));
      return locations;
    },

    // 获取所有地区
    getAllAdGroupLocations() {
      let mapLocations = [];
      try {
        this.data.adGroupOptions.forEach((v, index) => {
          mapLocations.push({
            groupId: `第${index + 1}个受众`,
            countryCodes: v.groupCriterion.target.locations.map((k) => k.country_code),
          });
        });
      } catch {}
      return mapLocations;
    },
    async getDefaultExcludeRegion() {
      const res = await fetchDefaultExcludeRegion(this.getAllAdGroupLocations());
      return res.data || [];
    },
    nextStep: debounce(async function () {
      if (this.isNextStepLoading) return;
      this.isNextStepLoading = true;

      try {
        if (this.current) {
          this.saveCreateStash();
        }
        switch (this.current) {
          case 1:
            this.$refs.campaignInfo.validate().then(() => {
              if (this.data.promoteInfo.sale.status == 4) {
                this.$confirm('该商品状态目前未上架，可能会产生无效花费；确定继续投放吗', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                })
                  .then((res) => {
                    const creatives = this.data.adOptions.map((item) => {
                      return {
                        ...item,
                        businessName: extractDomain(this.data.promoteInfo.promotionLink),
                      };
                    });
                    this.$set(this.data, 'adOptions', creatives);
                    this.current += 1;
                    this.$refs.audience.clearValidate();
                  })
                  .catch((res) => {});
              } else {
                const creatives = this.data.adOptions.map((item) => {
                  return {
                    ...item,
                    businessName: extractDomain(this.data.promoteInfo.promotionLink),
                  };
                });
                this.$set(this.data, 'adOptions', creatives);
                this.current += 1;
                this.$refs.audience.clearValidate();
              }
            });
            break;
          case 2:
            this.$refs.audience.validate().then(async () => {
              const excludeData = await this.getDefaultExcludeRegion();
              if (excludeData && excludeData.length) {
                const messageLines = excludeData.map(
                  (item) => `${item.groupId} 默认排除 ${item.excludeRegions.map((v) => v.name).join('、')}`,
                );

                this.$msgbox({
                  title: '默认排除地区提示',
                  message: this.$createElement('div', [
                    ...messageLines.map((line) => this.$createElement('div', { style: 'margin-bottom: 8px;' }, line)),
                    this.$createElement(
                      'div',
                      { style: 'color: #E6A23C; margin-top: 12px;font-size:12px' },
                      '公司该地区发不了货，若受众里面没有排除，后台会自动排除',
                    ),
                  ]),
                  showCancelButton: false,
                  confirmButtonText: '确定',
                }).then(() => {
                  this.current += 1;
                  this.$refs.creatives.clearValidate();
                });
              } else {
                this.current += 1;
                this.$refs.creatives.clearValidate();
              }
            });
            break;

          case 3:
            this.$refs.creatives.validate().then(async (res) => {
              let list = this.data.adOptions.map((v) => {
                if (v.type == 'DEMAND_GEN_VIDEO_RESPONSIVE_AD') {
                  return v.videoAssets;
                } else {
                  return [];
                }
              });
              console.log(list);
              if (list.filter((v) => v).length) {
                try {
                  this.$showLoading();
                  const videoAllValidate = await checkVideo({
                    locations: this.getAllLocations(),
                    videoAssets: list
                      .flat()
                      .map((v) => {
                        if (v.type !== 'getByUrl') {
                          return {
                            videoId: v.videoId,
                            name: v.videoName,
                            youtubeChannelId: v.youtubeChannelId,
                            thumbnail: v.thumbnail,
                            fileId: v.fileId,
                          };
                        }
                      })
                      .filter((v) => v),
                  });
                  this.$hideLoading();
                  if (videoAllValidate.code === 0 && videoAllValidate.data) {
                    this.current += 1;
                    // 进入第四步拆分表格
                    this.$nextTick(() => {
                      this.$refs.trackCreat.splitView();
                    });
                  }
                } catch {
                  console.log(this.data);
                }
              } else {
                this.current += 1;
                // 进入第四步拆分表格
                this.$nextTick(() => {
                  this.$refs.trackCreat.splitView();
                });
              }
            });
            break;
          case 4:
            // 点击确认
            this.$refs.trackCreat.creatAdsClick();
            break;
        }
      } finally {
        this.isNextStepLoading = false;
      }
    }, 300),
    getEnumConstants() {
      this.loading = true;
      adConstMapGG()
        .then((res) => {
          if (res.code == 0) {
            this.enumConstants.countries = res.data.defaultCountries;
            this.enumConstants.languages = res.data.defaultLanguages;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getAllAdAccountId(list) {
      this.allAdAccountId = list;
    },
    exit() {
      this.$router.push({
        name: 'googleAd',
        query: {
          account_id: this.createAdAccount.id,
          credentialUserId: localStorage.getItem('googleCredentialUserId'),
        },
      });
    },
    // 修改推广连接
    changePromotionLink() {
      // 清空受众和创意
      this.data.adGroupOptions = [getAudienceDefault()]; // 受众
      this.data.adOptions = [getImgCreative()]; // 创意
    },
    // 修改系列跟踪配置
    changeCampaignTraceConfig(v) {},
  },
  created() {
    // console.log(this.createAdAccount, 'createAdAccountcreateAdAccount');
    // this.getAccount();
    this.getEnumConstants();
  },
  async mounted() {
    this.$store.dispatch('app/closeSideBar');
    await this.getCreateStash();
  },
  beforeRouteLeave(to, form, next) {
    this.$confirm('确定关闭当前创建广告页面吗', {
      confirmButtonText: '退出',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then((res) => {
        this.saveCreateStash();
        this.$store.dispatch('app/openSideBar');
        next();
      })
      .catch(() => {
        next(false);
      });
  },
};
</script>
<style lang="scss">
.createWrap {
  .el-input,
  .el-select {
    width: 80%;
  }
  .el-select > .el-input {
    width: 100%;
  }
}
</style>
<style lang="scss" scoped>
.createWrap {
  height: calc(100vh - 220px);
  overflow-y: scroll;
  flex: auto;
}
.con {
  height: calc(100% - 80px);
}
::v-deep .el-tabs__content {
  height: calc(100% - 120px);
  overflow: auto;
  overflow-y: hidden;
}
</style>
